import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'booking-loading-page',
  templateUrl: './booking-loading-page.component.html',
  styleUrls: ['./booking-loading-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingLoadingPageComponent {
  router = inject(Router);

  goBack() {
    void this.router.navigate([``], { queryParamsHandling: 'merge' });
  }
}
